import { ActionBase } from './action-base';
import { type } from '../../shared/components/helpers/util';

/**
 * Dealer Option Action Types
 */
export const DEALER_OPTION_ACTION = {
  LOAD: type('DEALER_OPTION_LOAD'),
  SET: type('DEALER_OPTION_SET'),
  CLEAR: type('DEALER_OPTION_CLEAR')
};

/**
 * DealerOptionActionLoad
 */
export class DealerOptionActionLoad implements ActionBase {
  public readonly type: string = DEALER_OPTION_ACTION.LOAD;
  constructor() {}
}

/**
 * DealerOptionActionSet
 */
export class DealerOptionActionSet implements ActionBase {
  public readonly type: string = DEALER_OPTION_ACTION.SET;
  constructor(public payload: any[]) {}
}

/**
 * DealerOptionActionClear
 */
export class DealerOptionActionClear implements ActionBase {
  public readonly type: string = DEALER_OPTION_ACTION.CLEAR;
  constructor() {}
}

export type Any = DealerOptionActionLoad |
DealerOptionActionSet |
DealerOptionActionClear;
